<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">综合查询:</div>
                <el-input v-model="conditionData.Multiple" size="small" placeholder="请输入"></el-input>
            </div>
            <!-- <div class="item">
                <div class="label">时间段:</div>
                <el-date-picker
                v-model="time"
                size="small"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
                </el-date-picker>       
            </div> -->
            <div class="item">
                <div class="label">开始日期:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">结束日期:</div>
                <el-date-picker
                v-model="conditionData.EndTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            
            <div class="item">
                <div class="label">状态:</div>
                <el-select v-model="conditionData.financeState" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in standTermStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">开票公司:</div>
                <el-select v-model="conditionData.CompanyName" size="small" placeholder="请选择" filterable>
                    <el-option
                    v-for="item in organizationList"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">立项类型:</div>
                <el-select v-model="conditionData.Category" size="small" placeholder="请选择" filterable>
                    <el-option
                    v-for="item in CategoryList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div class="handle-r">
                    <el-button type="success" icon="el-icon-download" size="small" @click="downloadExcel(3)">下载批量编辑模板</el-button>
                    <el-upload
                        :action="uploadUrl"
                        Multiple
                        :show-file-list="false"
                        :http-request="UpdateBatch"
                        
                        >
                        <el-button type="primary" icon="el-icon-upload" size="small" style="margin-left:10px">批量修改</el-button>
                    </el-upload>
                    <el-button type="success" icon="el-icon-download" size="small" @click="downloadList()" style="margin-left:10px">导出立项</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                
                <el-table-column
                prop="standProjectId"
                width="120"
                label="立项ID"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="立项名称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="category"
                label="立项类型"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceNo"
                label="发票号"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceCode"
                label="发票编码"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="invoicePrice"
                label="发票金额"
                align="center"
                width="120"
                
                >
                </el-table-column>
                <el-table-column
                prop="actualPrice"
                label="实际收金额"
                align="center"
                width="120"
                >
                </el-table-column>
                <el-table-column
                prop="company"
                label="公司"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="companyCodeName"
                label="委托公司全称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="organization"
                label="开票公司"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="状态"
                align="center"
                width="200"
                
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==10">已开票未回款</span>
                    <span v-if="scope.row.financeState==15">已开票部分回款</span>
                    <span v-if="scope.row.financeState==20">回款完成</span>
                    <span v-if="scope.row.financeState==25">已收款未开票</span>
                    <span v-if="scope.row.financeState==1">其他</span>
                    <span v-if="scope.row.financeState==30">红冲</span>
                    <span v-if="scope.row.financeState==35">作废</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="invoicingTime"
                label="开票时间"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="creatTime"
                label="创建时间"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="240px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-search" size="mini" @click="detail(scope.row)">查看详情</el-button>
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
                    <!-- <el-button type="text" icon="el-icon-more" size="mini" @click="showRelevanceDialog(scope.row)">关联案件</el-button> -->
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next,total"
                    :total="totalCount"
                    :current-page="conditionData.pageIndex"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>

        
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="详情" :modal-append-to-body="true" width="1200px">
            <div class="dialog dialog-a">
                <div class="item">
                    <div class="label">
                        立项类型:
                    </div>
                    <div class="item-input">
                        <el-select v-model="detailData.carType" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in carTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        立项名称:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.standTermName" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        状态:
                    </div>
                    <div class="item-input">
                        <el-select v-model="detailData.financeState" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in standTermStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票号:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.invoiceNo" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票编码:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.invoiceCode" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.invoiceMoney" size="small" type="number" placeholder=""></el-input>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        实际收金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.actualPrice" size="small" type="number" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        上传缩略图:
                    </div>
                    <div class="item-input">
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="uploadimgUrl"
                            >
                            <el-button icon="el-icon-upload2" type="primary" size="small">点击上传</el-button>
                        </el-upload>
                        <div class="item-imgs">
                            <el-image
                            style="width: 100px; height: 100px"
                            :src="item"
                            v-for="(item,index) in imgUrlList"
                            :key="index"
                            :preview-src-list="[item]"
                            fit="cover"></el-image>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        公司:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.company" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        开票时间:
                    </div>
                    <div class="item-input">
                        <el-date-picker
                        v-model="detailData.billingTime"
                        type="datetime"
                        placeholder="选择日期时间">
                        </el-date-picker>
                        <!-- <el-input v-model="detailData.billingTime" size="small" placeholder=""></el-input> -->
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        附件:
                    </div>
                    <div class="item-input">
                        <el-upload
                            :action="uploadUrl"
                            Multiple
                            :show-file-list="false"
                            :http-request="uploadFileUp"
                            >
                            <el-button icon="el-icon-upload2" type="primary" size="small">点击上传</el-button>
                        </el-upload>
                        <el-button icon="el-icon-download" type="primary" size="small" v-if="detailData.fileUp" @click="download(detailData.fileUp)" style="margin-left:10px">下载查看</el-button>
                        
                    </div>
                </div>
                
                

                <!-- <div class="item">
                    <div class="label">
                        开票总金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.total" size="small" placeholder=""></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        委托公司全称:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.wholeCompanyName" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        快递单号:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.expressOrderNumber" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        收件人:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.receivingPeople" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        联系电话:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.telephone" size="small" placeholder=""></el-input>
                    </div>
                </div>


                <div class="item item-ta">
                    <el-table
                    :data="remarksTable"
                    border
                    style="width:980px">
                        <el-table-column
                        prop=""
                        label="备注记录"
                        >
                        <template slot-scope="scope">
                            <span>{{scope.row}}</span>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isEditDialog" title="编辑" width="1200px">
            <div class="dialog dialog-a">
                <div class="item">
                    <div class="label">
                        <span>*</span>
                        立项类型:
                    </div>
                    <div class="item-input">
                        <el-select v-model="editData.standType" size="small" placeholder="请选择" disabled>
                            <el-option
                            v-for="item in standTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <span>*</span>
                        立项名称:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.name" size="small" placeholder="" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        上传缩略图:
                    </div>
                    <div class="item-input">
                        <!-- <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="uploadimgUrl"
                            >
                            <el-button icon="el-icon-upload2" type="primary" size="small">点击上传</el-button>
                        </el-upload> -->
                        <div class="item-imgs">
                            <div style="width: 100px; height: 100px" class="item-img" v-for="(item,index) in imgUrlList" :key="index" v-if="item">
                                <!-- <div class="icon" @click="deleteImg(index)">
                                    <i class="el-icon-delete"></i>
                                </div> -->
                                <el-image
                                style="width: 100px; height: 100px"
                                :src="item"
                                :preview-src-list="[item]"
                                fit="cover"></el-image>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票号:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.invoiceNo" size="small" placeholder="" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票编码:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.invoiceCode" size="small" placeholder="" disabled></el-input>
                    </div>
                </div>

                
                <div class="item">
                    <div class="label">
                        发票金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.invoicePrice" size="small" type="number" placeholder="" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        状态:
                    </div>
                    <div class="item-input">
                        <el-select v-model="editData.financeState" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in standTermStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        实际收金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.actualPrice" size="small" type="number" placeholder=""></el-input>
                    </div>
                </div>
                 <div class="item">
                    <div class="label">
                        到账时间:
                    </div>
                    <div class="item-input">
                        <el-date-picker
                        v-model="editData.arrivalTime"
                        size="small"
                        type="datetime"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        到账金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.arrivalMoney" size="small" type="number" placeholder="" @blur="arrivalMoneyChange" @input="isInputChange"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        公司:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.company" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <span>*</span>
                        开票时间:
                    </div>
                    <div class="item-input"  disabled>
                        <el-date-picker
                        v-model="editData.invoicingTime"
                        size="small"
                        type="datetime"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>

                
                <div class="item">
                    <div class="label">
                        <span>*</span>
                        委托公司全称:
                    </div>
                    <div class="item-input">
                        <el-autocomplete
                            class="inline-input"
                            v-model="editData.companyCodeName"
                            :fetch-suggestions="querySearch"
                            placeholder=""
                            :trigger-on-focus="false"   
                            @select="handleSelect"
                            @keyup.enter.native="search"
                            size="small"
                             disabled
                        >
                            <template slot-scope="{ item }">
                                <div class="name">{{ item.subjectName}}</div>
                            </template>
                        </el-autocomplete>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        快递单号:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.expressOrderNumber" size="small" placeholder=""  disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        收件人:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.receivingPeople" size="small" placeholder=""  disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        联系电话:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.telephone" size="small" placeholder=""  disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        开票内容:
                    </div>
                    <div class="item-textarea" style="width:320px">
                        <el-input v-model="editData.billingContent" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item item-ta">
                    <div class="label">
                        备注:
                    </div>
                    <div class="item-textarea">
                        <el-input v-model="remarks" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <el-table
                    :data="remarksTable"
                    border
                    style="width: 510px">
                        <el-table-column
                        prop=""
                        label="备注记录"
                        >
                        <template slot-scope="scope">
                            <span>{{scope.row}}</span>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="edit">确认提交</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isRelevanceDialog" title="关联案件" width="1200px">
            <div class="uploadbtn">
                <div class="l"></div>
                <el-upload
                    :action="uploadUrl"
                    Multiple
                    :show-file-list="false"
                    :http-request="importAssets"
                    
                    >
                    <el-button icon="el-icon-upload" type="success" size="small" style="margin-bottom:10px">导入excel</el-button>
                </el-upload>
            </div>
            <el-table
                :data="caseList"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="caseNo"
                label="报案号"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="caseName"
                label="案件名称"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="entrust"
                label="委托日期"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="entrustPeople"
                label="委托人"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="reportNo"
                label="报案号"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="省市区"
                align="center"
                width="200"
                
                >
                <template slot-scope="scope">
                    <span>{{scope.row.province}}{{scope.row.city}}</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="addressInfo"
                label="详细地址"
                align="center"
                width="200"
                
                >
                
                </el-table-column>
                
                <el-table-column
                prop="financeState"
                label="财务状态"
                align="center"
                width="100"
                >
                </el-table-column>
               
                <el-table-column
                prop="assessCost"
                label="评估费"
                align="center"
                width="100"
                >
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCaseCurrentChange"
                    background
                    layout="prev, pager, next,total"
                    :total="totalCountCase"
                    :current-page="conditionCaseData.pageIndex"
                    :page-size="conditionCaseData.pageSize">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS,parseTimeD,accAdd,accSubtract} from '../../../utils/index'
import {assetStandTermStatus,carTypeList,standTypeList,companyTypeList,businessModuleList} from '../../../assets/selectList/assetsSelectList'
export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            standTypeList:standTypeList,
            time:'',
            uploadUrl:'',
            title:'',
            isAddDialog:false,
            isDetailDialog:false,
            isEditDialog:false,
            isRelevanceDialog:false,
            totalCount:0,
            totalCountCase:0,
            conditionData:localStorage.getItem('selectData')?JSON.parse(localStorage.getItem('selectData')):{
                Multiple:"",
                StartTime:"",
                EndTime:"",
                Company:"",
                financeState:null,
                pageIndex:1,
                pageSize:10,
            },
            conditionCaseData:{
                standProjectId:"",
                pageIndex:1,
                pageSize:10,
            },
            tableData:[],
            detailData:{},
            addData:{
                
            },
            editData:{
                standType:null,
                name:null,
                invoiceNo:null,
                invoiceCode:null,
                invoicePrice:null,
                actualPrice:null,
                company:null,
                invoicingTime:null,
                companyCodeName:null,
                expressOrderNumber:null,
                receivingPeople:null,
                telephone:null,
                billingContent:null,
                remarks:'',
                financeState:null,
                arrivalTime:null,
                arrivalMoney:null,
            },
            imgUrlList:[],
            caseList:[],
            standProjectId:'',
            standTermStatus:assetStandTermStatus,
            carTypeList:carTypeList,
            remarksTable:[],
            remarks:[],
            actualPrice:0,
            isInput:false,
            organizationList:[],
            CategoryList:[{
                label:'全部',
                value:''
            },{
                label:'资产评估',
                value:'资产评估'
            },{
                label:'财产险',
                value:'财产险'
            }],
        }
    },
    created(){
        

    },
    mounted(){
        console.log(this.standTermStatus);
        this.loadingData();
        this.statisticsGetCompany();
    },
    methods:{
        async statisticsGetCompany(){
            let res = await api.statisticsGetCompany();
            this.organizationList = res.data.data
        },
        // 批量修改
        async UpdateBatch(file){
            let res = await api.upCWSandProjectA(file.file,{
                userName:localStorage.getItem("userName")
            });
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                this.loadingData();
            }
        },
        downloadExcel(type){
            this.$message({
                type: 'success',
                message: '正在下载，请稍等!'
            })
            const elt = document.createElement('a');
            if(type == 3){
                elt.setAttribute('href', 'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210813/20210813100906kQSZf');
			    elt.setAttribute('download', '立项批量编辑模板');
            }
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        async getCaseList(row){
            this.conditionCaseData.standProjectId = row.standProjectId?row.standProjectId:this.standProjectId;
            let res = await api.getCasePagedListAssets(this.conditionCaseData);
            console.log(res);
            this.caseList = res.data.data.entitys;
            this.totalCountCase = res.data.data.pageLen;
            if(res.data.code == 200){
                this.isRelevanceDialog = true;
            }
            for(let i in this.caseList){
                this.caseList[i].entrust = parseTimeS(this.caseList[i].entrust)
            }
            
        },
        async submit(){
            this.addData.type = 1;
             if(this.addData.invoiceMoney){
                this.addData.invoiceMoney = parseFloat(this.addData.invoiceMoney);
            }else{
                this.addData.invoiceMoney = 0;
            }
            if(this.addData.actualPrice){
                this.addData.actualPrice = parseFloat(this.addData.actualPrice);
            }else{
                this.addData.actualPrice = 0;
            }
            // this.addData.billingTime = parseTimeS(this.addData.billingTime);
            let res = await api.putAssets(this.addData);
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '插入成功!'
                });
                this.isAddDialog = false;
                this.loadingData();
            }
            
        },
        async uploadFileUp(file){
            let res = await api.uploadOther(file.file);
            console.log(res);
            this.addData.fileUp = res;
            this.$forceUpdate();
        },
        async uploadimgUrl(file){
            let res = await api.uploadOther(file.file);
            this.addData.imgUrl = res;
            this.$forceUpdate();
        },
        async uploadFileUpE(file){
            let res = await api.uploadOther(file.file);
            console.log(res);
            this.editData.fileUp = res;
            this.$forceUpdate();
        },
        async uploadimgUrlE(file){
            let res = await api.uploadOther(file.file);
            this.editData.imgUrl = res;
            this.$forceUpdate();
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            if(this.time){
                this.conditionData.startTime = parseTimeD(this.time[0]);
                this.conditionData.endTime = parseTimeD(this.time[1]);
            }
            let res  = await api.getAssetsList(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.entitys;
            this.totalCount = res.data.data.pageLen;
            for(let i in this.tableData){
                this.tableData[i].billingTimeStr = parseTimeD(this.tableData[i].billingTime)
            }
        },
        selectData(){
            this.conditionData.pageIndex = 1;
            this.loadingData();
        },
        reset(){
            this.time = '',
            this.conditionData = {
                Multiple:"",
                StartTime:"",
                EndTime:"",
                Company:"",
                financeState:null,
                pageIndex:1,
                pageSize:10,
            },
            this.loadingData();
        },
        handleCurrentChange(pageIndex){
            this.conditionData.pageIndex = pageIndex;
            this.loadingData();
        },
        handleCaseCurrentChange(pageIndex){
            this.conditionCaseData.pageIndex = pageIndex;
            this.getCaseList()
        },
        detail(row){
            localStorage.setItem('selectData',JSON.stringify(this.conditionData))
            this.editData.standProjectId = row.standProjectId;
            this.editData.standType = row.standType;
            this.editData.name = row.name;
            this.editData.invoiceNo = row.invoiceNo;
            this.editData.imgUrl = row.imgUrl;
            if(row.imgUrl){
                this.imgUrlList = row.imgUrl.split(',');
            }else{
                this.imgUrlList = [];
            }
            this.editData.invoiceCode = row.invoiceCode;
            this.editData.invoicePrice = row.invoicePrice;
            this.editData.invoiceNo = row.invoiceNo;
            this.editData.invoicingTime = row.invoicingTime;
            
            this.editData.actualPrice = row.actualPrice;
            // this.editData.remarks = row.remarks;
            if(row.remarks){
                this.remarksTable = row.remarks.split('<remarksTable>');
            }else{
                this.remarksTable = [];
            }
            this.editData.relatedID = row.relatedID;
            this.editData.standTermName = row.standTermName;
            this.editData.type = row.type;
            this.editData.standType = row.standType;
            this.editData.total = row.total;
            this.editData.companyCodeName = row.companyCodeName;
            this.editData.company = row.company;
            this.editData.expressOrderNumber = row.expressOrderNumber;
            this.editData.receivingPeople = row.receivingPeople;
            this.editData.telephone = row.telephone;
            this.editData.sellerName = row.sellerName;
            this.editData.organization = row.organization;
            this.editData.billingContent = row.billingContent;
            
            this.editData.projectPeople = localStorage.getItem("userName");
            localStorage.setItem('editData',JSON.stringify(row));
            this.$router.push({
                name:'assetsAppraisalSettlementProjectDetail',
                query:{
                    id:row.standProjectId,
                    isDetail:true,
                }
            })
        },
        showEditDialog(row){
            this.isInput = false;
            this.editData.standProjectId = row.standProjectId;
            this.editData.standType = row.standType;
            this.editData.name = row.name;
            this.editData.invoiceNo = row.invoiceNo;
            this.editData.imgUrl = row.imgUrl;
            this.editData.financeState = row.financeState;
            if(row.imgUrl){
                this.imgUrlList = row.imgUrl.split(',');
            }else{
                this.imgUrlList = [];
            }
            this.editData.invoiceCode = row.invoiceCode;
            this.editData.invoicePrice = row.invoicePrice;
            this.editData.invoiceNo = row.invoiceNo;
            this.editData.invoicingTime = row.invoicingTime;
            
            this.editData.actualPrice = row.actualPrice;
            // this.editData.remarks = row.remarks;
            if(row.remarks){
                this.remarksTable = row.remarks.split('<remarksTable>');
            }else{
                this.remarksTable = [];
            }
            this.editData.relatedID = row.relatedID;
            this.editData.standTermName = row.standTermName;
            this.editData.type = row.type;
            this.editData.standType = row.standType;
            this.editData.total = row.total;
            this.editData.companyCodeName = row.companyCodeName;
            this.editData.company = row.company;
            this.editData.expressOrderNumber = row.expressOrderNumber;
            this.editData.receivingPeople = row.receivingPeople;
            this.editData.telephone = row.telephone;
            this.editData.sellerName = row.sellerName;
            this.editData.organization = row.organization;
            this.editData.billingContent = row.billingContent;
            this.editData.arrivalMoney = row.arrivalMoney;
            this.editData.arrivalTime = row.arrivalTime;
            this.editData.projectPeople = localStorage.getItem("userName");
            this.isEditDialog = true;
        },
        showAddDialog(){
            this.isAddDialog = true;
        },
        showRelevanceDialog(row){
            this.getCaseList(row);
            this.standProjectId = row.standProjectId
        },
        async edit(){
            if(this.editData.invoiceMoney){
                this.editData.invoiceMoney = parseFloat(this.editData.invoiceMoney);
            }else{
                this.editData.invoiceMoney = 0;
            }
            if(this.editData.actualPrice){
                this.editData.actualPrice = parseFloat(this.editData.actualPrice);
            }else{
                this.editData.actualPrice = 0;
            }

            if(this.editData.arrivalMoney){
                this.editData.arrivalMoney = parseFloat(this.editData.arrivalMoney);
            }else{
                this.editData.arrivalMoney = 0;
            }
            
            if(this.editData.arrivaldiFference){
                this.editData.arrivaldiFference = parseFloat(this.editData.arrivaldiFference);
            }else{
                this.editData.arrivaldiFference = 0;
            }

            for(let index in this.remarksTable){
                if(index==0){
                    this.editData.remarks = this.remarksTable[index]
                }else{
                    this.editData.remarks = this.editData.remarks + '<remarksTable>' + this.remarksTable[index]
                }
            }
            if(this.remarks&&this.remarks.length>0){
                if(this.editData.remarks){
                    this.editData.remarks = this.editData.remarks + '<remarksTable>' + this.remarks
                }else{
                    this.editData.remarks = this.remarks
                }
            }
            let res = await api.updateAssets(this.editData);
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
                this.remarks = '',
                this.isEditDialog = false;
                this.loadingData();
            }
        },
        // 导入
        async importAssets(file){
            console.log(file);
            console.log(this.standProjectId);
            let res = await api.importAssets(file.file,{
                standProjectId:this.standProjectId
            });
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '导入成功!'
                });
                this.getCaseList({standProjectId:this.standProjectId});
            }
        },
        // 下载
        download(url){
            this.$message({
                type: 'success',
                message: '正在下载，请稍等!'
            })
            const elt = document.createElement('a');
            elt.setAttribute('href', url);
            // elt.setAttribute('download', 'file.png');
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        async downloadList(){
            let option = {};
            if(this.conditionData.Multiple){
                option.Multiple = this.conditionData.Multiple;
            }
            if(this.conditionData.isLocalCase){
                option.ISLocalCase = this.conditionData.isLocalCase;
            }
            if(this.conditionData.StartTime){
                option.StartTime = this.conditionData.StartTime;
            }
            if(this.conditionData.EndTime){
                option.EndTime = this.conditionData.EndTime;
            }
           
            let res = await api.standExportA(option);
        },
        isInputChange(){
            this.isInput = true;
        },
        arrivalMoneyChange(){
            if(!this.isInput){
                return;
            }
            this.editData.actualPrice = accAdd(this.editData.actualPrice,this.editData.arrivalMoney);
            this.isInput=false;
        },
    }
    
}
</script>

<style lang="scss" scoped>
    // /deep/.el-dialog__wrapper{
    //     z-index: 101 !important;
    // }
    /deep/.el-image-viewer__wrapper{
        z-index: 9999 !important;
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color: #606266;
        border: 1px solid #DCDFE6;
    } 
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 8px 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 7px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
            .handle-r{
                display: flex;
            }
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            
            font-size: 14px;
            padding:10px 150px;
            display: flex;
            align-items: center;
            justify-content: center;
            .label{
                min-width: 110px;
                margin-bottom: 5px;
            }
            .item-input{
                width: 300px;
                display: flex;
                align-items: center;
            }
            .item-imgs{
                width: 400px;
                display: flex;
                flex-wrap: wrap;
                margin-top: 10px;
                .item-img{
                    position: relative;
                    margin-right: 10px;
                    margin-bottom: 10px;
                    .icon{
                        right: 0;
                        top: 0;
                        position:absolute;
                        z-index: 100;
                        color: #ffffff;
                        background-color: #000000;
                        width: 18px;
                        height: 18px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }

                }
            }
            /deep/.el-image{
                margin-left: 10px;
            }
            .item-textarea{
                width: 400px;
            }
        }
        
        .dialog-footer{
            width: 100%;
            display: flex;
            justify-content: center;
            .el-button{
                margin-top: 20px;
            }
        }
        
    }
    .dialog-a{
        .item{
            font-size: 14px;
            padding:10px 50px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .item-ta{
            width:920px;
            .item-textarea{
                width: 960px;
            }
        }
        
    }
    .uploadbtn{
            width: 100%;
            display: flex;
            flex-direction: row-reverse;
            // .l{
            //     width: 100%;
            // }
        }
</style>
